export default __webpack_public_path__ + "static/media/download.f1d2aaba.svg";